import { useEffect } from 'react'
import { useToast } from '../hooks/useToast'

const ToastItem = ({ toast, onClose }) => {
  const bgColor = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    warning: 'bg-yellow-500',
    info: 'bg-blue-500'
  }[toast.type] || 'bg-gray-500'

  useEffect(() => {
    const timer = setTimeout(() => onClose(toast.id), toast.duration)
    return () => clearTimeout(timer)
  }, [toast.id, toast.duration, onClose])

  return (
    <div className={`${bgColor} text-white px-4 py-3 rounded shadow-lg mb-2 flex justify-between items-center min-w-[300px]`}>
      <span>{toast.message}</span>
      <button onClick={() => onClose(toast.id)} className="ml-4 text-white hover:text-gray-200 font-bold">×</button>
    </div>
  )
}

export default function Toast() {
  const { toasts, removeToast } = useToast()

  return (
    <div className="fixed top-4 right-4 z-50">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onClose={removeToast} />
      ))}
    </div>
  )
}